import React from 'react'

import AddCompanyForm from '../../modules/Company/components/AddCompanyForm'
export default function AddBranchPage() {
  return <AddCompanyForm />
}
